
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Activity": [
      "CreatedCommentActivity",
      "CreatedHistoryActivity",
      "CreatedTopicActivity",
      "FillerActivity",
      "JoinedUserActivity",
      "PublishedPostActivity",
      "RepliedCommentActivity",
      "ThankedPostActivity"
    ],
    "MentionContent": [
      "MentionContentDelta",
      "MentionContentHighlights",
      "MentionContentSlack"
    ],
    "Notification": [
      "CommentNotification",
      "HistoryNotification",
      "InvitationNotification",
      "PostNotification",
      "ReactionNotification"
    ],
    "ObjectWithId": [
      "Organization",
      "PublicOrganization",
      "PublicSeries",
      "PublicTopic",
      "PublicUser",
      "RedactedTopic",
      "Section",
      "Series",
      "SlimSeries",
      "SlimTopic",
      "SlimUser",
      "Topic",
      "User",
      "VisitorUser"
    ],
    "PostBacklink": [
      "Group",
      "Post",
      "Topic",
      "User"
    ],
    "PublicAnnotationFields": [
      "Annotation",
      "PublicAnnotation"
    ],
    "PublicCommentFields": [
      "Comment",
      "PublicComment"
    ],
    "PublicCommentReactionFields": [
      "CommentReaction",
      "PublicCommentReaction"
    ],
    "PublicGroupFields": [
      "Group",
      "PublicGroup"
    ],
    "PublicOrganizationFields": [
      "Organization",
      "PublicOrganization"
    ],
    "PublicOrganizationSettingsFields": [
      "OrganizationSettings",
      "PublicOrganizationSettings"
    ],
    "PublicPostFields": [
      "Post",
      "PublicPost"
    ],
    "PublicReactionFields": [
      "PublicReaction",
      "Reaction"
    ],
    "PublicSearchResult": [
      "PublicPostSearchResult",
      "PublicTopicSearchResult"
    ],
    "PublicSeriesFields": [
      "PublicSeries",
      "Series"
    ],
    "PublicThreadFields": [
      "PublicThread",
      "Thread"
    ],
    "PublicTopicFields": [
      "PublicTopic",
      "Topic"
    ],
    "PublicUserFields": [
      "PublicUser",
      "User",
      "VisitorUser"
    ],
    "RedactedTopicFields": [
      "RedactedTopic",
      "Topic"
    ],
    "RootPostFields": [
      "Post",
      "PublicPost",
      "SlimPost"
    ],
    "SearchResult": [
      "CommentSearchResult",
      "GroupSearchResult",
      "PostSearchResult",
      "TopicSearchResult",
      "UserSearchResult"
    ],
    "SectionItem": [
      "Post",
      "Topic"
    ],
    "SessionFields": [
      "Session",
      "VisitorSession"
    ],
    "SlimExternalPostFields": [
      "ExternalPost",
      "SlimExternalPost"
    ],
    "SlimHistoryFields": [
      "History",
      "SlimHistory"
    ],
    "SlimPostFields": [
      "Post",
      "SlimPost"
    ]
  }
};
      export default result;
    